import React from 'react'
import { Link } from 'react-router-dom'
import { routesDef } from '../../config/routes'
import { useUser } from '../../hooks/useUser'
import { Logout } from '../Logout'
import { HorizontalStack, Switch } from '@ztechapps/webui.util'
import { truncate } from '@ztechapps/common.utils'
import { HeaderWidgetContainer } from '../../components/Header/header-widget/HeaderWidgetContainer'

export const UserWidget = () => {
  const { loggedIn } = useUser()

  return (
    <HeaderWidgetContainer>
      <Switch expression={!!loggedIn}>
        {{
          true: <WelcomeUser />,
          false: <WelcomeGuest />,
        }}
      </Switch>
    </HeaderWidgetContainer>
  )
}

export const WelcomeGuest = () => {
  return (
    <div>
      <small>Welcome guest!</small>
      <HorizontalStack gap={2}>
        <Link to={routesDef.LoginPage.altPath()}>Sign in</Link>
        <div>|</div>
        <Link to={routesDef.RegisterPage.altPath}>Register</Link>
      </HorizontalStack>
    </div>
  )
}

export const WelcomeUser = () => {
  const { user } = useUser()

  return (
    <div>
      <small>Hello {truncate(user?.profile?.name ?? '', 15)}!</small>
      <HorizontalStack gap={2}>
        <Logout>Logout</Logout>
        <div>|</div>
        <Link to={routesDef.AccountOverview.path}>My account</Link>
      </HorizontalStack>
    </div>
  )
}
